(() => {
    window.addEventListener('DOMContentLoaded', () => {
      const text = document.getElementById('collection-description');
      const btnMore = document.getElementById('toggleReadDescBtn');
      const btnLess = document.getElementById('toggleLessDescBtn');
  
      if (!text || !btnMore || !btnLess) return;
  
      function isClamped(el) {
        return el.scrollHeight > el.clientHeight + 1;
      }
  
      function checkClamp() {
        if (isClamped(text)) {
          btnMore.style.display = 'inline';
          btnLess.style.display = 'none';
        } else {
          btnMore.style.display = 'none';
          btnLess.style.display = 'none';
        }
      }
  
      checkClamp();
  
      btnMore.addEventListener('click', () => {
        text.classList.add('expanded');
        btnMore.style.display = 'none';
        btnLess.style.display = 'inline';
      });
  
      btnLess.addEventListener('click', () => {
        text.classList.remove('expanded');
        btnMore.style.display = 'inline';
        btnLess.style.display = 'none';
      });
  
      window.addEventListener('resize', checkClamp);
    });
  })();